import request from "@/router/axios";

const notificationUrl = "/sg-user-service/v1/notification";

export function listBase(isLogin, lang, cateId) {
  return request({
    url: notificationUrl + "/listBase",
    method: "get",
    params: {
      langCode: lang,
      isLogin: isLogin,
      cateId: cateId
    }
  });
}

export function listNotification(loginView, langCode, noticeType, pageNum, pageSize) {
  return request({
    url: notificationUrl + "/listNotification",
    method: "get",
    params: {
      loginView: loginView,
      langCode: langCode,
      noticeType: noticeType,
      pageNum: pageNum,
      pageSize: pageSize
    }
  });
}

export function getNotificationById(id) {
  return request({
    url: notificationUrl + "/getById",
    method: "get",
    params: {
      id: id
    }
  });
}

const findHomeCateUrl = "/sg-user-service/v1/cooperation";

export function findHome(lang) {
  return request({
    url: findHomeCateUrl + "/findHomeObj",
    method: "get",
    params: {
      langCode: lang
    }
  });
}



// WEBPACK FOOTER //
// ./src/api/sigen/techNotification.js